import request from './request'
import crewordRequest from './crewordRequest'
// get的拼接处理
function montage(data) {
  if (typeof data !== 'object') return ''
  let str = '?'
  let list = Object.keys(data)
  list.forEach((el, i) => {
    if (i === list.length - 1) {
      str += `${el}=${data[el]}`
    } else {
      str += `${el}=${data[el]}&`
    }
  })
  return str
}
// 任务榜 - 接单
export function receivingOrders(data) {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/receivingOrders',
    method: 'post',
    data,
  })
}
// 架构师本人专业服务列表展示
export function showProfessionalServicesList(data) {
  return crewordRequest({
    url: `newAiwriting/showProfessionalServicesList`,
    method: "post",
    data
  });
}
// 添加用户专业服务产品项目流程
export function addProjectProcess(data) {
  return crewordRequest({
    url: `wqwriter/twq-professional-services-specs/add`,
    method: "post",
    data
  });
}

// 获取AI成文架构师简介
export function architectInfo(data) {
  return crewordRequest({
    url: `aiCase/architectInfo`,
    method: "post",
    data,
    header: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
}
// 点击关注
export function clickInterest(data) {
  return crewordRequest({
    url: "userAttention/add/" + data,
    method: "get",
    header: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
}
// 点击取消关注
export function clickCancelInterest(data) {
  return crewordRequest({
    url: "userAttention/cancel/" + data,
    method: "get",
    header: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
}
// 甲方任务合同录入信息查询
export function queryATaskUserEnterInfo(data) {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/queryATaskUserEnterInfo',
    method: 'get',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 写手评论查询
export function findCommentsByTarget(data) {
  return crewordRequest({
    url: `writer-service-entrust-order/findCommentsByTarget`,
    method: 'post',
    data,
  })
}
// 服务购买(任务发起人)
export function servicesBuy(data) {
  return crewordRequest({
    url: `wqtask/twq-professional-services-task/servicesBuy`,
    method: "post",
    data
  });
}
// 查询专业服务下的规格
export function servicesProjectSpecs(data) {
  return crewordRequest({
    url: `twq-professional-services/servicesProjectSpecs`,
    method: "post",
    data,
    header: {
      "content-type": "application/x-www-form-urlencoded",
    }
  });
}
// 查询专业服务下的规格
export function servicesProject(data) {
  return crewordRequest({
    url: `twq-professional-services/servicesProject`,
    method: "post",
    data,
    header: {
      "content-type": "application/x-www-form-urlencoded",
    }
  });
}
// 查询AI成文稿详情
export function findCaseDetail(data) {
  return crewordRequest({
    url: `case/findCaseDetail`,
    method: "post",
    data,
    header: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
}
// 查询专业服务详情
export function servicesInfo(data) {
  return crewordRequest({
    url: `twq-professional-services/servicesInfo`,
    method: "post",
    data,
    header: {
      "content-type": "application/x-www-form-urlencoded",
    }
  });
}
// 拒绝任务结果
export function examine(data) {
  return crewordRequest({
    url: 'wqtask/task-track/examine',
    method: 'post',
    data,
  })
}
// 验收任务（任务发起人）
export function checkAccept(data) {
  return crewordRequest({
    url: 'wqtask/task-track/checkAccept',
    method: 'post',
    data,
  })
}
// 受理（确认接单 接单人
export function taskConfirmAccepted(data) {
  return crewordRequest({
    url: 'wqtask/task-track/taskConfirmAccepted',
    method: 'post',
    data,
  })
}
// 任务合同乙方录入信息查询
export function queryBTaskUserEnterInfo(data) {
  return crewordRequest({
    url:
      'wqtask/twq-professional-services-task/queryBTaskUserEnterInfo' +
      montage(data),
    method: 'get',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 授权查询
export function queryTwqMandate() {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/queryTwqMandate',
    method: 'get',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 案由查询
export function queryTwqCaseCause(data) {
  return crewordRequest({
    url:
      'wqtask/twq-professional-services-task/queryTwqCaseCause' + montage(data),
    method: 'get',
  })
}
// 单方终止委托接口（接单人）
export function entrustTaskEnd(data) {
  return crewordRequest({
    url: 'wqtask/task-track/entrustTaskEnd',
    method: 'post',
    data,
  })
}
// 专业服务任务详情
export function serviceTaskInfo(id) {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/taskInfo?taskId=' + id,
    method: 'get',
  })
}
//获取任务类型
export function practiceType() {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/practiceType',
    method: 'GET',
  })
}
// 获取用户专业服务执业资格列表
export function userPracticingQualification(data) {
  return crewordRequest({
    url: 'twq-professional-services-practice/practices',
    method: 'get',
  })
}
// 获取用户信息
export function userInfo(data) {
  return crewordRequest({
    url: 'user/wqUserInfo',
    method: 'get',
  })
}
// 获取任务榜
export function taskList(data) {
  return crewordRequest({
    url: '/wqtask/twq-professional-services-task/taskList',
    method: 'POST',
    data
  })
}
// 获取新申请执业资格列表
export function getNewApplicantList(data) {
  return crewordRequest({
    url:
      'twq-professional-services-practice-track/getUserApplicantList' +
      montage(data),
    method: 'get',
  })
}
// 获取执业榜
export function practiceList(data) {
  return crewordRequest({
    url: '/wqtask/twq-professional-services-task/practiceList',
    method: 'POST',
    data
  })
}

// 关注
export function follow(id) {
  return crewordRequest({
    url: `/userAttention/add/${id}`,
    method: 'GET',
  })
}
// 订单支付状态查询
export function payOrderQuery(data) {
  return crewordRequest({
    url: `wqzh-order/payOrderQuery`,
    method: "post",
    data
  });
}
// 删除用户专业服务产品项目
export function deleteServicesFlowPath(data) {
  return crewordRequest({
    url: 'wqwriter/twq-professional-services-specs/delete',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}

// 获取用户专业服务产品项目流程列表
export function getProjectProcess(data) {
  return crewordRequest({
    url:
      'wqwriter/twq-professional-services-specs/servicesSpecs?projectId=' + data,
    method: 'get',
  })
}
// 获取地址信息
export function taskAreaList(data) {
  return crewordRequest({
    url:
      '/wqtask/twq-professional-services-task/taskAreaList',
    method: 'post',
    data
  })
}
// 查询个人专业服务执业资格信息
export function getServicesPracticeInfo(data) {
  return crewordRequest({
    url:
      'twq-professional-services-practice/getServicesPracticeInfo' +
      montage(data),
    method: 'get',
  })
}
// 订单支付
export function orderPayment(data) {
  return crewordRequest({
    url: `wqzh-order/pay`,
    method: "post",
    data
  });
}

// 识别营业执照信息
export function enterpriseCertification(data) {
  return crewordRequest({
    url: 'user/enterpriseCertification',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 申请专业服务执业资格
export function AddApplyPracticing(data) {
  return crewordRequest({
    url: 'twq-professional-services-practice-track/add',
    method: 'post',
    data,
  })
}
// 新增专业服务产品列表
export function servicesProductList(data) {
  return crewordRequest({
    url: '/twq-professional-services/list?typeId=' + data,
    method: 'post',


  })
}
// 添加执业资格类型申请
export function addPracticeApply(data) {
  return crewordRequest({
    url: 'twq-professional-services-practice-type-track/add',
    method: 'post',
    data,
  })
}
// 执业资格类型审核列表
export function PracticeReviewList(data) {
  return crewordRequest({
    url: 'twq-professional-services-practice-type-track/list',
    method: 'get',
  })
}
// 改简历
export function modifyResume(data) {
  return crewordRequest({
    url: 'user/userInfoUpd',
    method: 'put',
    data,
  })
}
// 实名认证
export function addRealname(data) {
  return crewordRequest({
    url: `realname/addRealname`,
    method: "post",
    data,
  });
}

// 删除身份证照
export function deleteIDCard(data) {
  return crewordRequest({
    url: 'user/deleteIDCard?flag=' + data,
    method: 'get',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}

// 识别身份证信息
export function identifyCardInfo(data) {
  return crewordRequest({
    url: 'user/identifyCardInfo',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 上传
export function ossUpload(data) {
  return crewordRequest({
    url: '/common/ossUpload',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 挖潜智库用户认证信息查询
export function getUserAuthenticationInfo() {
  return crewordRequest({
    url: 'user/getUserAuthenticationInfo',
    method: 'post',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 删除专业服务产品
export function deleteServices(data) {
  return crewordRequest({
    url: '/twq-professional-services/delete',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 修改专业服务产品状态
export function modifyServices(data) {
  return crewordRequest({
    url: 'twq-professional-services/update',
    method: 'post',
    data,
  })
}
// 添加用户的专业服务产品项目列表
export function addListOfServiceItems(data) {
  return crewordRequest({
    url: 'wqwriter/twq-professional-services-project/add',
    method: 'post',
    data,
  })
}
// 删除用户专业服务产品项目
export function deleteServicesProducts(data) {
  return crewordRequest({
    url: 'wqwriter/twq-professional-services-project/delete',
    method: 'post',
    data,
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 获取用户的专业服务产品项目列表
export function listOfServiceItems(data) {
  return crewordRequest({
    url:
      'wqwriter/twq-professional-services-project/servicesProject' +
      montage(data),
    method: 'get',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}
// 新增专业服务产品
export function addServicesProduct(data) {
  return crewordRequest({
    url: '/twq-professional-services/add',
    method: 'post',
    data,
  })
}
// 取消关注
export function cancelFollow(id) {
  return crewordRequest({
    url: `/userAttention/cancel/${id}`,
    method: 'GET',
  })
}
// 获取任务详情
export function taskInfo(id) {
  return crewordRequest({
    url: `/wqtask/twq-professional-services-task/taskInfo?taskId=${id}`,
    method: 'GET',
  })
}

// 获取我的任务
export function myQuest(data) {
  return crewordRequest({
    url: `/wqtask/twq-professional-services-task/queryPublishAndReceiveOrderTaskProgress`,
    method: 'post',
    data
  })
}

// 催催任务(任务发起人)
export function taskUrge(data) {
  return crewordRequest({
    url: '/wqtask/task-track/taskUrge',
    method: 'post',
    data,
  })
}

export function closeTask(data) {
  return crewordRequest({
    url: '/wqtask/task-track/closeTask',
    method: 'post',
    data,
  })
}

// 终止补偿计算(任务发起人)
export function taskEndRedressInfo(data) {
  return crewordRequest({
    url: '/wqtask/task-track/taskEndRedressInfo' + montage(data),
    method: 'get',
  })
}

// 终止补偿(任务发起人)
export function taskEndRedress(data) {
  return crewordRequest({
    url: '/wqtask/task-track/taskEndRedress',
    method: 'post',
    data,
  })
}

// 提交验收(接单人)
export function submitAcceptance(data) {
  return crewordRequest({
    url: '/wqtask/task-track/submitAcceptance',
    method: 'post',
    data,
  })
}

// 反馈进度(接单人)
export function feedbackProgress(data) {
  return crewordRequest({
    url: '/wqtask/task-track/feedbackProgress',
    method: 'post',
    data,
  })
}

// 用户协议列表
export function getAgreementList() {
  return crewordRequest({
    url: '/wqzkSystem/getAgreementList',
    method: 'get',
    header: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  })
}

// 发布执业任务
export function publishTask(data) {
  return crewordRequest({
    url: 'wqtask/twq-professional-services-task/publishTask',
    method: 'post',
    data,
  })
}

// 用户原创列表
export function myOriginalWorksPageList(data) {
  return crewordRequest({
    url: '/wqoriginal/twq-original-works/myOriginalWorksPageList',
    method: 'post',
    data,
  })
}

// 查询AI成文的生成结果
export function showQueryAiWritingResult(data) {
  return crewordRequest({
    url: '/newAiwriting/showQueryAiWritingResult',
    method: 'post',
    data,
  })
}
// 查询AI成文的生成结果
export function orderPageList(params) {
  return crewordRequest({
    url: '/order/tps-order/wq/pageList',
    method: 'get',
    params,
  })
}

// 获取订单详情
export function orderDetails(params) {
  return crewordRequest({
    url: '/order/tps-order/wq/orderDetails',
    method: 'get',
    params,
  })
}


// 撤销订单
export function cancelOrder(data) {
  return crewordRequest({
    url: '/order/tps-order/cancelOrder',
    method: 'post',
    data,

  })

}


// 识别营业执照信息
export function identifyBusinessLicense(data) {
  return crewordRequest({
    url: '/user/identifyBusinessLicense',
    method: 'post',
    data,
  })
}


// wqtask/task-track/modifyTask
export function modifyTask(data) {
  return crewordRequest({
    url: '/wqtask/task-track/modifyTask',
    method: 'post',
    data,
  })
}

// 关注列表(专业服务人员)
export function attentionServiceUser(data) {
  return crewordRequest({
    url: '/userAttention/attentionServiceUser',
    method: 'post',
    data,
  })
}

// 提现资金收支统计查询
export function selectCashWithdrawSum(data) {
  return crewordRequest({
    url: '/order/tps-order/selectCashWithdrawSum',
    method: 'post',
    data,
  })
}

// 提现资金收支查询
export function selectCashWithdraw(data) {
  return crewordRequest({
    url: '/order/tps-order/selectCashWithdraw',
    method: 'post',
    data,
  })
}

// 查询订单现金可提金额
export function selectOrderCashWithdraw() {
  return crewordRequest({
    url: 'order/tps-order/selectOrderCashWithdraw',
    method: 'get',
  })
}

// 提现申请查询
export function pageWithdrawCash(data) {
  return crewordRequest({
    url: 'order/tps-order/pageWithdrawCash',
    method: 'post',
    data,
  })
}

// 提现申请
export function withdrawCash(data) {
  return crewordRequest({
    url: 'order/tps-order/withdrawCash',
    method: 'post',
    data,
  })
}